import { Navigate } from "react-router-dom";
import useDeviceCompatibility from "../../hooks/useDeviceCompatibility";

export function CompatibleRoute({ children }) {
  const isCompatible = useDeviceCompatibility();
  return isCompatible ? children : <Navigate to="/compatibility" replace />;
}
